
export class EventDefinition {
    Id: string;
    name: string;
    triggerAction = 'Pass';
    Async = false;
    SignalRef: string;
    constructor() { }
}
